/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated/search'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedManualRouteImport } from './routes/_authenticated/manual'
import { Route as AuthenticatedInvestigationsRouteImport } from './routes/_authenticated/investigations'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedGroupsIndexRouteImport } from './routes/_authenticated/groups.index'
import { Route as AuthenticatedEntitiesIndexRouteImport } from './routes/_authenticated/entities.index'
import { Route as AuthenticatedAlertsIndexRouteImport } from './routes/_authenticated/alerts/index'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedProfilerIdRouteImport } from './routes/_authenticated/profiler.$id'
import { Route as AuthenticatedMessagesIdRouteImport } from './routes/_authenticated/messages.$id'
import { Route as AuthenticatedInvestigationsIdRouteImport } from './routes/_authenticated/investigations.$id'
import { Route as AuthenticatedGroupsIdRouteImport } from './routes/_authenticated/groups.$id'
import { Route as AuthenticatedEntitiesIdRouteImport } from './routes/_authenticated/entities.$id'
import { Route as AuthenticatedAlertsNewRouteImport } from './routes/_authenticated/alerts/new'
import { Route as AuthenticatedAlertsHistoryRouteImport } from './routes/_authenticated/alerts/history'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminSystemHealthRouteImport } from './routes/_authenticated/admin/system-health'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminRolesRouteImport } from './routes/_authenticated/admin/roles'
import { Route as AuthenticatedAdminMonitoringRouteImport } from './routes/_authenticated/admin/monitoring'
import { Route as AuthenticatedAdminMaintenanceRouteImport } from './routes/_authenticated/admin/maintenance'
import { Route as AuthenticatedAdminLicenseRouteImport } from './routes/_authenticated/admin/license'
import { Route as AuthenticatedAdminGroupsRouteImport } from './routes/_authenticated/admin/groups'
import { Route as AuthenticatedAdminEntityConfigRouteImport } from './routes/_authenticated/admin/entity-config'
import { Route as AuthenticatedAdminDataStatsRouteImport } from './routes/_authenticated/admin/data-stats'
import { Route as AuthenticatedAdminComplianceRouteImport } from './routes/_authenticated/admin/compliance'
import { Route as AuthenticatedAdminCollectionRouteImport } from './routes/_authenticated/admin/collection'
import { Route as AuthenticatedAdminAuditLogRouteImport } from './routes/_authenticated/admin/audit-log'
import { Route as AuthenticatedAdminApiKeysRouteImport } from './routes/_authenticated/admin/api-keys'
import { Route as AuthenticatedAdminMonitoringIndexRouteImport } from './routes/_authenticated/admin/monitoring/index'
import { Route as AuthenticatedAdminCollectionIndexRouteImport } from './routes/_authenticated/admin/collection/index'
import { Route as AuthenticatedAlertsIdEditRouteImport } from './routes/_authenticated/alerts/$id.edit'
import { Route as AuthenticatedAdminPipelineDlqRouteImport } from './routes/_authenticated/admin/pipeline/dlq'
import { Route as AuthenticatedAdminMonitoringNotificationsRouteImport } from './routes/_authenticated/admin/monitoring/notifications'
import { Route as AuthenticatedAdminMonitoringAlertsRouteImport } from './routes/_authenticated/admin/monitoring/alerts'
import { Route as AuthenticatedAdminComplianceExportsRouteImport } from './routes/_authenticated/admin/compliance/exports'
import { Route as AuthenticatedAdminCollectionConnectionsRouteImport } from './routes/_authenticated/admin/collection/connections'
import { Route as AuthenticatedAdminCollectionAlertsRouteImport } from './routes/_authenticated/admin/collection/alerts'
import { Route as AuthenticatedAdminApiKeysIdRouteImport } from './routes/_authenticated/admin/api-keys/$id'
import { Route as AuthenticatedAdminCollectionAvatarsNewRouteImport } from './routes/_authenticated/admin/collection/avatars/new'
import { Route as AuthenticatedAdminCollectionAvatarsIdRouteImport } from './routes/_authenticated/admin/collection/avatars/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManualRoute = AuthenticatedManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvestigationsRoute =
  AuthenticatedInvestigationsRouteImport.update({
    id: '/investigations',
    path: '/investigations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsIndexRoute =
  AuthenticatedGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesIndexRoute =
  AuthenticatedEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAlertsIndexRoute =
  AuthenticatedAlertsIndexRouteImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilerIdRoute = AuthenticatedProfilerIdRouteImport.update({
  id: '/profiler/$id',
  path: '/profiler/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMessagesIdRoute = AuthenticatedMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvestigationsIdRoute =
  AuthenticatedInvestigationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedInvestigationsRoute,
  } as any)
const AuthenticatedGroupsIdRoute = AuthenticatedGroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEntitiesIdRoute = AuthenticatedEntitiesIdRouteImport.update({
  id: '/entities/$id',
  path: '/entities/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAlertsNewRoute = AuthenticatedAlertsNewRouteImport.update({
  id: '/alerts/new',
  path: '/alerts/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAlertsHistoryRoute =
  AuthenticatedAlertsHistoryRouteImport.update({
    id: '/alerts/history',
    path: '/alerts/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSystemHealthRoute =
  AuthenticatedAdminSystemHealthRouteImport.update({
    id: '/system-health',
    path: '/system-health',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRolesRoute = AuthenticatedAdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminMonitoringRoute =
  AuthenticatedAdminMonitoringRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMaintenanceRoute =
  AuthenticatedAdminMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLicenseRoute =
  AuthenticatedAdminLicenseRouteImport.update({
    id: '/license',
    path: '/license',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminGroupsRoute =
  AuthenticatedAdminGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminEntityConfigRoute =
  AuthenticatedAdminEntityConfigRouteImport.update({
    id: '/entity-config',
    path: '/entity-config',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDataStatsRoute =
  AuthenticatedAdminDataStatsRouteImport.update({
    id: '/data-stats',
    path: '/data-stats',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminComplianceRoute =
  AuthenticatedAdminComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCollectionRoute =
  AuthenticatedAdminCollectionRouteImport.update({
    id: '/collection',
    path: '/collection',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditLogRoute =
  AuthenticatedAdminAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminApiKeysRoute =
  AuthenticatedAdminApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMonitoringIndexRoute =
  AuthenticatedAdminMonitoringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminMonitoringRoute,
  } as any)
const AuthenticatedAdminCollectionIndexRoute =
  AuthenticatedAdminCollectionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminCollectionRoute,
  } as any)
const AuthenticatedAlertsIdEditRoute =
  AuthenticatedAlertsIdEditRouteImport.update({
    id: '/alerts/$id/edit',
    path: '/alerts/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPipelineDlqRoute =
  AuthenticatedAdminPipelineDlqRouteImport.update({
    id: '/pipeline/dlq',
    path: '/pipeline/dlq',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMonitoringNotificationsRoute =
  AuthenticatedAdminMonitoringNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAdminMonitoringRoute,
  } as any)
const AuthenticatedAdminMonitoringAlertsRoute =
  AuthenticatedAdminMonitoringAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedAdminMonitoringRoute,
  } as any)
const AuthenticatedAdminComplianceExportsRoute =
  AuthenticatedAdminComplianceExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthenticatedAdminComplianceRoute,
  } as any)
const AuthenticatedAdminCollectionConnectionsRoute =
  AuthenticatedAdminCollectionConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedAdminCollectionRoute,
  } as any)
const AuthenticatedAdminCollectionAlertsRoute =
  AuthenticatedAdminCollectionAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedAdminCollectionRoute,
  } as any)
const AuthenticatedAdminApiKeysIdRoute =
  AuthenticatedAdminApiKeysIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAdminApiKeysRoute,
  } as any)
const AuthenticatedAdminCollectionAvatarsNewRoute =
  AuthenticatedAdminCollectionAvatarsNewRouteImport.update({
    id: '/avatars/new',
    path: '/avatars/new',
    getParentRoute: () => AuthenticatedAdminCollectionRoute,
  } as any)
const AuthenticatedAdminCollectionAvatarsIdRoute =
  AuthenticatedAdminCollectionAvatarsIdRouteImport.update({
    id: '/avatars/$id',
    path: '/avatars/$id',
    getParentRoute: () => AuthenticatedAdminCollectionRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/investigations': typeof AuthenticatedInvestigationsRouteWithChildren
  '/manual': typeof AuthenticatedManualRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/search': typeof AuthenticatedSearchRoute
  '/admin/api-keys': typeof AuthenticatedAdminApiKeysRouteWithChildren
  '/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/admin/collection': typeof AuthenticatedAdminCollectionRouteWithChildren
  '/admin/compliance': typeof AuthenticatedAdminComplianceRouteWithChildren
  '/admin/data-stats': typeof AuthenticatedAdminDataStatsRoute
  '/admin/entity-config': typeof AuthenticatedAdminEntityConfigRoute
  '/admin/groups': typeof AuthenticatedAdminGroupsRoute
  '/admin/license': typeof AuthenticatedAdminLicenseRoute
  '/admin/maintenance': typeof AuthenticatedAdminMaintenanceRoute
  '/admin/monitoring': typeof AuthenticatedAdminMonitoringRouteWithChildren
  '/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/system-health': typeof AuthenticatedAdminSystemHealthRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/alerts/history': typeof AuthenticatedAlertsHistoryRoute
  '/alerts/new': typeof AuthenticatedAlertsNewRoute
  '/entities/$id': typeof AuthenticatedEntitiesIdRoute
  '/groups/$id': typeof AuthenticatedGroupsIdRoute
  '/investigations/$id': typeof AuthenticatedInvestigationsIdRoute
  '/messages/$id': typeof AuthenticatedMessagesIdRoute
  '/profiler/$id': typeof AuthenticatedProfilerIdRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/groups/': typeof AuthenticatedGroupsIndexRoute
  '/admin/api-keys/$id': typeof AuthenticatedAdminApiKeysIdRoute
  '/admin/collection/alerts': typeof AuthenticatedAdminCollectionAlertsRoute
  '/admin/collection/connections': typeof AuthenticatedAdminCollectionConnectionsRoute
  '/admin/compliance/exports': typeof AuthenticatedAdminComplianceExportsRoute
  '/admin/monitoring/alerts': typeof AuthenticatedAdminMonitoringAlertsRoute
  '/admin/monitoring/notifications': typeof AuthenticatedAdminMonitoringNotificationsRoute
  '/admin/pipeline/dlq': typeof AuthenticatedAdminPipelineDlqRoute
  '/alerts/$id/edit': typeof AuthenticatedAlertsIdEditRoute
  '/admin/collection/': typeof AuthenticatedAdminCollectionIndexRoute
  '/admin/monitoring/': typeof AuthenticatedAdminMonitoringIndexRoute
  '/admin/collection/avatars/$id': typeof AuthenticatedAdminCollectionAvatarsIdRoute
  '/admin/collection/avatars/new': typeof AuthenticatedAdminCollectionAvatarsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/investigations': typeof AuthenticatedInvestigationsRouteWithChildren
  '/manual': typeof AuthenticatedManualRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/search': typeof AuthenticatedSearchRoute
  '/admin/api-keys': typeof AuthenticatedAdminApiKeysRouteWithChildren
  '/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/admin/compliance': typeof AuthenticatedAdminComplianceRouteWithChildren
  '/admin/data-stats': typeof AuthenticatedAdminDataStatsRoute
  '/admin/entity-config': typeof AuthenticatedAdminEntityConfigRoute
  '/admin/groups': typeof AuthenticatedAdminGroupsRoute
  '/admin/license': typeof AuthenticatedAdminLicenseRoute
  '/admin/maintenance': typeof AuthenticatedAdminMaintenanceRoute
  '/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/system-health': typeof AuthenticatedAdminSystemHealthRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/alerts/history': typeof AuthenticatedAlertsHistoryRoute
  '/alerts/new': typeof AuthenticatedAlertsNewRoute
  '/entities/$id': typeof AuthenticatedEntitiesIdRoute
  '/groups/$id': typeof AuthenticatedGroupsIdRoute
  '/investigations/$id': typeof AuthenticatedInvestigationsIdRoute
  '/messages/$id': typeof AuthenticatedMessagesIdRoute
  '/profiler/$id': typeof AuthenticatedProfilerIdRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/alerts': typeof AuthenticatedAlertsIndexRoute
  '/entities': typeof AuthenticatedEntitiesIndexRoute
  '/groups': typeof AuthenticatedGroupsIndexRoute
  '/admin/api-keys/$id': typeof AuthenticatedAdminApiKeysIdRoute
  '/admin/collection/alerts': typeof AuthenticatedAdminCollectionAlertsRoute
  '/admin/collection/connections': typeof AuthenticatedAdminCollectionConnectionsRoute
  '/admin/compliance/exports': typeof AuthenticatedAdminComplianceExportsRoute
  '/admin/monitoring/alerts': typeof AuthenticatedAdminMonitoringAlertsRoute
  '/admin/monitoring/notifications': typeof AuthenticatedAdminMonitoringNotificationsRoute
  '/admin/pipeline/dlq': typeof AuthenticatedAdminPipelineDlqRoute
  '/alerts/$id/edit': typeof AuthenticatedAlertsIdEditRoute
  '/admin/collection': typeof AuthenticatedAdminCollectionIndexRoute
  '/admin/monitoring': typeof AuthenticatedAdminMonitoringIndexRoute
  '/admin/collection/avatars/$id': typeof AuthenticatedAdminCollectionAvatarsIdRoute
  '/admin/collection/avatars/new': typeof AuthenticatedAdminCollectionAvatarsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/investigations': typeof AuthenticatedInvestigationsRouteWithChildren
  '/_authenticated/manual': typeof AuthenticatedManualRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/admin/api-keys': typeof AuthenticatedAdminApiKeysRouteWithChildren
  '/_authenticated/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/_authenticated/admin/collection': typeof AuthenticatedAdminCollectionRouteWithChildren
  '/_authenticated/admin/compliance': typeof AuthenticatedAdminComplianceRouteWithChildren
  '/_authenticated/admin/data-stats': typeof AuthenticatedAdminDataStatsRoute
  '/_authenticated/admin/entity-config': typeof AuthenticatedAdminEntityConfigRoute
  '/_authenticated/admin/groups': typeof AuthenticatedAdminGroupsRoute
  '/_authenticated/admin/license': typeof AuthenticatedAdminLicenseRoute
  '/_authenticated/admin/maintenance': typeof AuthenticatedAdminMaintenanceRoute
  '/_authenticated/admin/monitoring': typeof AuthenticatedAdminMonitoringRouteWithChildren
  '/_authenticated/admin/roles': typeof AuthenticatedAdminRolesRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/system-health': typeof AuthenticatedAdminSystemHealthRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/alerts/history': typeof AuthenticatedAlertsHistoryRoute
  '/_authenticated/alerts/new': typeof AuthenticatedAlertsNewRoute
  '/_authenticated/entities/$id': typeof AuthenticatedEntitiesIdRoute
  '/_authenticated/groups/$id': typeof AuthenticatedGroupsIdRoute
  '/_authenticated/investigations/$id': typeof AuthenticatedInvestigationsIdRoute
  '/_authenticated/messages/$id': typeof AuthenticatedMessagesIdRoute
  '/_authenticated/profiler/$id': typeof AuthenticatedProfilerIdRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/_authenticated/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/_authenticated/groups/': typeof AuthenticatedGroupsIndexRoute
  '/_authenticated/admin/api-keys/$id': typeof AuthenticatedAdminApiKeysIdRoute
  '/_authenticated/admin/collection/alerts': typeof AuthenticatedAdminCollectionAlertsRoute
  '/_authenticated/admin/collection/connections': typeof AuthenticatedAdminCollectionConnectionsRoute
  '/_authenticated/admin/compliance/exports': typeof AuthenticatedAdminComplianceExportsRoute
  '/_authenticated/admin/monitoring/alerts': typeof AuthenticatedAdminMonitoringAlertsRoute
  '/_authenticated/admin/monitoring/notifications': typeof AuthenticatedAdminMonitoringNotificationsRoute
  '/_authenticated/admin/pipeline/dlq': typeof AuthenticatedAdminPipelineDlqRoute
  '/_authenticated/alerts/$id/edit': typeof AuthenticatedAlertsIdEditRoute
  '/_authenticated/admin/collection/': typeof AuthenticatedAdminCollectionIndexRoute
  '/_authenticated/admin/monitoring/': typeof AuthenticatedAdminMonitoringIndexRoute
  '/_authenticated/admin/collection/avatars/$id': typeof AuthenticatedAdminCollectionAvatarsIdRoute
  '/_authenticated/admin/collection/avatars/new': typeof AuthenticatedAdminCollectionAvatarsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/dashboard'
    | '/investigations'
    | '/manual'
    | '/notifications'
    | '/search'
    | '/admin/api-keys'
    | '/admin/audit-log'
    | '/admin/collection'
    | '/admin/compliance'
    | '/admin/data-stats'
    | '/admin/entity-config'
    | '/admin/groups'
    | '/admin/license'
    | '/admin/maintenance'
    | '/admin/monitoring'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/system-health'
    | '/admin/users'
    | '/alerts/history'
    | '/alerts/new'
    | '/entities/$id'
    | '/groups/$id'
    | '/investigations/$id'
    | '/messages/$id'
    | '/profiler/$id'
    | '/settings/profile'
    | '/alerts/'
    | '/entities/'
    | '/groups/'
    | '/admin/api-keys/$id'
    | '/admin/collection/alerts'
    | '/admin/collection/connections'
    | '/admin/compliance/exports'
    | '/admin/monitoring/alerts'
    | '/admin/monitoring/notifications'
    | '/admin/pipeline/dlq'
    | '/alerts/$id/edit'
    | '/admin/collection/'
    | '/admin/monitoring/'
    | '/admin/collection/avatars/$id'
    | '/admin/collection/avatars/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/dashboard'
    | '/investigations'
    | '/manual'
    | '/notifications'
    | '/search'
    | '/admin/api-keys'
    | '/admin/audit-log'
    | '/admin/compliance'
    | '/admin/data-stats'
    | '/admin/entity-config'
    | '/admin/groups'
    | '/admin/license'
    | '/admin/maintenance'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/system-health'
    | '/admin/users'
    | '/alerts/history'
    | '/alerts/new'
    | '/entities/$id'
    | '/groups/$id'
    | '/investigations/$id'
    | '/messages/$id'
    | '/profiler/$id'
    | '/settings/profile'
    | '/alerts'
    | '/entities'
    | '/groups'
    | '/admin/api-keys/$id'
    | '/admin/collection/alerts'
    | '/admin/collection/connections'
    | '/admin/compliance/exports'
    | '/admin/monitoring/alerts'
    | '/admin/monitoring/notifications'
    | '/admin/pipeline/dlq'
    | '/alerts/$id/edit'
    | '/admin/collection'
    | '/admin/monitoring'
    | '/admin/collection/avatars/$id'
    | '/admin/collection/avatars/new'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/admin'
    | '/_authenticated/dashboard'
    | '/_authenticated/investigations'
    | '/_authenticated/manual'
    | '/_authenticated/notifications'
    | '/_authenticated/search'
    | '/_authenticated/admin/api-keys'
    | '/_authenticated/admin/audit-log'
    | '/_authenticated/admin/collection'
    | '/_authenticated/admin/compliance'
    | '/_authenticated/admin/data-stats'
    | '/_authenticated/admin/entity-config'
    | '/_authenticated/admin/groups'
    | '/_authenticated/admin/license'
    | '/_authenticated/admin/maintenance'
    | '/_authenticated/admin/monitoring'
    | '/_authenticated/admin/roles'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/system-health'
    | '/_authenticated/admin/users'
    | '/_authenticated/alerts/history'
    | '/_authenticated/alerts/new'
    | '/_authenticated/entities/$id'
    | '/_authenticated/groups/$id'
    | '/_authenticated/investigations/$id'
    | '/_authenticated/messages/$id'
    | '/_authenticated/profiler/$id'
    | '/_authenticated/settings/profile'
    | '/_authenticated/alerts/'
    | '/_authenticated/entities/'
    | '/_authenticated/groups/'
    | '/_authenticated/admin/api-keys/$id'
    | '/_authenticated/admin/collection/alerts'
    | '/_authenticated/admin/collection/connections'
    | '/_authenticated/admin/compliance/exports'
    | '/_authenticated/admin/monitoring/alerts'
    | '/_authenticated/admin/monitoring/notifications'
    | '/_authenticated/admin/pipeline/dlq'
    | '/_authenticated/alerts/$id/edit'
    | '/_authenticated/admin/collection/'
    | '/_authenticated/admin/monitoring/'
    | '/_authenticated/admin/collection/avatars/$id'
    | '/_authenticated/admin/collection/avatars/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/manual': {
      id: '/_authenticated/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof AuthenticatedManualRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investigations': {
      id: '/_authenticated/investigations'
      path: '/investigations'
      fullPath: '/investigations'
      preLoaderRoute: typeof AuthenticatedInvestigationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/': {
      id: '/_authenticated/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthenticatedGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/': {
      id: '/_authenticated/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof AuthenticatedEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/': {
      id: '/_authenticated/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AuthenticatedAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profiler/$id': {
      id: '/_authenticated/profiler/$id'
      path: '/profiler/$id'
      fullPath: '/profiler/$id'
      preLoaderRoute: typeof AuthenticatedProfilerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/$id': {
      id: '/_authenticated/messages/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AuthenticatedMessagesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investigations/$id': {
      id: '/_authenticated/investigations/$id'
      path: '/$id'
      fullPath: '/investigations/$id'
      preLoaderRoute: typeof AuthenticatedInvestigationsIdRouteImport
      parentRoute: typeof AuthenticatedInvestigationsRoute
    }
    '/_authenticated/groups/$id': {
      id: '/_authenticated/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof AuthenticatedGroupsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/$id': {
      id: '/_authenticated/entities/$id'
      path: '/entities/$id'
      fullPath: '/entities/$id'
      preLoaderRoute: typeof AuthenticatedEntitiesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/new': {
      id: '/_authenticated/alerts/new'
      path: '/alerts/new'
      fullPath: '/alerts/new'
      preLoaderRoute: typeof AuthenticatedAlertsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/history': {
      id: '/_authenticated/alerts/history'
      path: '/alerts/history'
      fullPath: '/alerts/history'
      preLoaderRoute: typeof AuthenticatedAlertsHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/system-health': {
      id: '/_authenticated/admin/system-health'
      path: '/system-health'
      fullPath: '/admin/system-health'
      preLoaderRoute: typeof AuthenticatedAdminSystemHealthRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/roles': {
      id: '/_authenticated/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AuthenticatedAdminRolesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/monitoring': {
      id: '/_authenticated/admin/monitoring'
      path: '/monitoring'
      fullPath: '/admin/monitoring'
      preLoaderRoute: typeof AuthenticatedAdminMonitoringRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/maintenance': {
      id: '/_authenticated/admin/maintenance'
      path: '/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AuthenticatedAdminMaintenanceRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/license': {
      id: '/_authenticated/admin/license'
      path: '/license'
      fullPath: '/admin/license'
      preLoaderRoute: typeof AuthenticatedAdminLicenseRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/groups': {
      id: '/_authenticated/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AuthenticatedAdminGroupsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/entity-config': {
      id: '/_authenticated/admin/entity-config'
      path: '/entity-config'
      fullPath: '/admin/entity-config'
      preLoaderRoute: typeof AuthenticatedAdminEntityConfigRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/data-stats': {
      id: '/_authenticated/admin/data-stats'
      path: '/data-stats'
      fullPath: '/admin/data-stats'
      preLoaderRoute: typeof AuthenticatedAdminDataStatsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/compliance': {
      id: '/_authenticated/admin/compliance'
      path: '/compliance'
      fullPath: '/admin/compliance'
      preLoaderRoute: typeof AuthenticatedAdminComplianceRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/collection': {
      id: '/_authenticated/admin/collection'
      path: '/collection'
      fullPath: '/admin/collection'
      preLoaderRoute: typeof AuthenticatedAdminCollectionRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit-log': {
      id: '/_authenticated/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AuthenticatedAdminAuditLogRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/api-keys': {
      id: '/_authenticated/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AuthenticatedAdminApiKeysRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/monitoring/': {
      id: '/_authenticated/admin/monitoring/'
      path: '/'
      fullPath: '/admin/monitoring/'
      preLoaderRoute: typeof AuthenticatedAdminMonitoringIndexRouteImport
      parentRoute: typeof AuthenticatedAdminMonitoringRoute
    }
    '/_authenticated/admin/collection/': {
      id: '/_authenticated/admin/collection/'
      path: '/'
      fullPath: '/admin/collection/'
      preLoaderRoute: typeof AuthenticatedAdminCollectionIndexRouteImport
      parentRoute: typeof AuthenticatedAdminCollectionRoute
    }
    '/_authenticated/alerts/$id/edit': {
      id: '/_authenticated/alerts/$id/edit'
      path: '/alerts/$id/edit'
      fullPath: '/alerts/$id/edit'
      preLoaderRoute: typeof AuthenticatedAlertsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/pipeline/dlq': {
      id: '/_authenticated/admin/pipeline/dlq'
      path: '/pipeline/dlq'
      fullPath: '/admin/pipeline/dlq'
      preLoaderRoute: typeof AuthenticatedAdminPipelineDlqRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/monitoring/notifications': {
      id: '/_authenticated/admin/monitoring/notifications'
      path: '/notifications'
      fullPath: '/admin/monitoring/notifications'
      preLoaderRoute: typeof AuthenticatedAdminMonitoringNotificationsRouteImport
      parentRoute: typeof AuthenticatedAdminMonitoringRoute
    }
    '/_authenticated/admin/monitoring/alerts': {
      id: '/_authenticated/admin/monitoring/alerts'
      path: '/alerts'
      fullPath: '/admin/monitoring/alerts'
      preLoaderRoute: typeof AuthenticatedAdminMonitoringAlertsRouteImport
      parentRoute: typeof AuthenticatedAdminMonitoringRoute
    }
    '/_authenticated/admin/compliance/exports': {
      id: '/_authenticated/admin/compliance/exports'
      path: '/exports'
      fullPath: '/admin/compliance/exports'
      preLoaderRoute: typeof AuthenticatedAdminComplianceExportsRouteImport
      parentRoute: typeof AuthenticatedAdminComplianceRoute
    }
    '/_authenticated/admin/collection/connections': {
      id: '/_authenticated/admin/collection/connections'
      path: '/connections'
      fullPath: '/admin/collection/connections'
      preLoaderRoute: typeof AuthenticatedAdminCollectionConnectionsRouteImport
      parentRoute: typeof AuthenticatedAdminCollectionRoute
    }
    '/_authenticated/admin/collection/alerts': {
      id: '/_authenticated/admin/collection/alerts'
      path: '/alerts'
      fullPath: '/admin/collection/alerts'
      preLoaderRoute: typeof AuthenticatedAdminCollectionAlertsRouteImport
      parentRoute: typeof AuthenticatedAdminCollectionRoute
    }
    '/_authenticated/admin/api-keys/$id': {
      id: '/_authenticated/admin/api-keys/$id'
      path: '/$id'
      fullPath: '/admin/api-keys/$id'
      preLoaderRoute: typeof AuthenticatedAdminApiKeysIdRouteImport
      parentRoute: typeof AuthenticatedAdminApiKeysRoute
    }
    '/_authenticated/admin/collection/avatars/new': {
      id: '/_authenticated/admin/collection/avatars/new'
      path: '/avatars/new'
      fullPath: '/admin/collection/avatars/new'
      preLoaderRoute: typeof AuthenticatedAdminCollectionAvatarsNewRouteImport
      parentRoute: typeof AuthenticatedAdminCollectionRoute
    }
    '/_authenticated/admin/collection/avatars/$id': {
      id: '/_authenticated/admin/collection/avatars/$id'
      path: '/avatars/$id'
      fullPath: '/admin/collection/avatars/$id'
      preLoaderRoute: typeof AuthenticatedAdminCollectionAvatarsIdRouteImport
      parentRoute: typeof AuthenticatedAdminCollectionRoute
    }
  }
}

interface AuthenticatedAdminApiKeysRouteChildren {
  AuthenticatedAdminApiKeysIdRoute: typeof AuthenticatedAdminApiKeysIdRoute
}

const AuthenticatedAdminApiKeysRouteChildren: AuthenticatedAdminApiKeysRouteChildren =
  {
    AuthenticatedAdminApiKeysIdRoute: AuthenticatedAdminApiKeysIdRoute,
  }

const AuthenticatedAdminApiKeysRouteWithChildren =
  AuthenticatedAdminApiKeysRoute._addFileChildren(
    AuthenticatedAdminApiKeysRouteChildren,
  )

interface AuthenticatedAdminCollectionRouteChildren {
  AuthenticatedAdminCollectionAlertsRoute: typeof AuthenticatedAdminCollectionAlertsRoute
  AuthenticatedAdminCollectionConnectionsRoute: typeof AuthenticatedAdminCollectionConnectionsRoute
  AuthenticatedAdminCollectionIndexRoute: typeof AuthenticatedAdminCollectionIndexRoute
  AuthenticatedAdminCollectionAvatarsIdRoute: typeof AuthenticatedAdminCollectionAvatarsIdRoute
  AuthenticatedAdminCollectionAvatarsNewRoute: typeof AuthenticatedAdminCollectionAvatarsNewRoute
}

const AuthenticatedAdminCollectionRouteChildren: AuthenticatedAdminCollectionRouteChildren =
  {
    AuthenticatedAdminCollectionAlertsRoute:
      AuthenticatedAdminCollectionAlertsRoute,
    AuthenticatedAdminCollectionConnectionsRoute:
      AuthenticatedAdminCollectionConnectionsRoute,
    AuthenticatedAdminCollectionIndexRoute:
      AuthenticatedAdminCollectionIndexRoute,
    AuthenticatedAdminCollectionAvatarsIdRoute:
      AuthenticatedAdminCollectionAvatarsIdRoute,
    AuthenticatedAdminCollectionAvatarsNewRoute:
      AuthenticatedAdminCollectionAvatarsNewRoute,
  }

const AuthenticatedAdminCollectionRouteWithChildren =
  AuthenticatedAdminCollectionRoute._addFileChildren(
    AuthenticatedAdminCollectionRouteChildren,
  )

interface AuthenticatedAdminComplianceRouteChildren {
  AuthenticatedAdminComplianceExportsRoute: typeof AuthenticatedAdminComplianceExportsRoute
}

const AuthenticatedAdminComplianceRouteChildren: AuthenticatedAdminComplianceRouteChildren =
  {
    AuthenticatedAdminComplianceExportsRoute:
      AuthenticatedAdminComplianceExportsRoute,
  }

const AuthenticatedAdminComplianceRouteWithChildren =
  AuthenticatedAdminComplianceRoute._addFileChildren(
    AuthenticatedAdminComplianceRouteChildren,
  )

interface AuthenticatedAdminMonitoringRouteChildren {
  AuthenticatedAdminMonitoringAlertsRoute: typeof AuthenticatedAdminMonitoringAlertsRoute
  AuthenticatedAdminMonitoringNotificationsRoute: typeof AuthenticatedAdminMonitoringNotificationsRoute
  AuthenticatedAdminMonitoringIndexRoute: typeof AuthenticatedAdminMonitoringIndexRoute
}

const AuthenticatedAdminMonitoringRouteChildren: AuthenticatedAdminMonitoringRouteChildren =
  {
    AuthenticatedAdminMonitoringAlertsRoute:
      AuthenticatedAdminMonitoringAlertsRoute,
    AuthenticatedAdminMonitoringNotificationsRoute:
      AuthenticatedAdminMonitoringNotificationsRoute,
    AuthenticatedAdminMonitoringIndexRoute:
      AuthenticatedAdminMonitoringIndexRoute,
  }

const AuthenticatedAdminMonitoringRouteWithChildren =
  AuthenticatedAdminMonitoringRoute._addFileChildren(
    AuthenticatedAdminMonitoringRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminApiKeysRoute: typeof AuthenticatedAdminApiKeysRouteWithChildren
  AuthenticatedAdminAuditLogRoute: typeof AuthenticatedAdminAuditLogRoute
  AuthenticatedAdminCollectionRoute: typeof AuthenticatedAdminCollectionRouteWithChildren
  AuthenticatedAdminComplianceRoute: typeof AuthenticatedAdminComplianceRouteWithChildren
  AuthenticatedAdminDataStatsRoute: typeof AuthenticatedAdminDataStatsRoute
  AuthenticatedAdminEntityConfigRoute: typeof AuthenticatedAdminEntityConfigRoute
  AuthenticatedAdminGroupsRoute: typeof AuthenticatedAdminGroupsRoute
  AuthenticatedAdminLicenseRoute: typeof AuthenticatedAdminLicenseRoute
  AuthenticatedAdminMaintenanceRoute: typeof AuthenticatedAdminMaintenanceRoute
  AuthenticatedAdminMonitoringRoute: typeof AuthenticatedAdminMonitoringRouteWithChildren
  AuthenticatedAdminRolesRoute: typeof AuthenticatedAdminRolesRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminSystemHealthRoute: typeof AuthenticatedAdminSystemHealthRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminPipelineDlqRoute: typeof AuthenticatedAdminPipelineDlqRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminApiKeysRoute: AuthenticatedAdminApiKeysRouteWithChildren,
  AuthenticatedAdminAuditLogRoute: AuthenticatedAdminAuditLogRoute,
  AuthenticatedAdminCollectionRoute:
    AuthenticatedAdminCollectionRouteWithChildren,
  AuthenticatedAdminComplianceRoute:
    AuthenticatedAdminComplianceRouteWithChildren,
  AuthenticatedAdminDataStatsRoute: AuthenticatedAdminDataStatsRoute,
  AuthenticatedAdminEntityConfigRoute: AuthenticatedAdminEntityConfigRoute,
  AuthenticatedAdminGroupsRoute: AuthenticatedAdminGroupsRoute,
  AuthenticatedAdminLicenseRoute: AuthenticatedAdminLicenseRoute,
  AuthenticatedAdminMaintenanceRoute: AuthenticatedAdminMaintenanceRoute,
  AuthenticatedAdminMonitoringRoute:
    AuthenticatedAdminMonitoringRouteWithChildren,
  AuthenticatedAdminRolesRoute: AuthenticatedAdminRolesRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminSystemHealthRoute: AuthenticatedAdminSystemHealthRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminPipelineDlqRoute: AuthenticatedAdminPipelineDlqRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedInvestigationsRouteChildren {
  AuthenticatedInvestigationsIdRoute: typeof AuthenticatedInvestigationsIdRoute
}

const AuthenticatedInvestigationsRouteChildren: AuthenticatedInvestigationsRouteChildren =
  {
    AuthenticatedInvestigationsIdRoute: AuthenticatedInvestigationsIdRoute,
  }

const AuthenticatedInvestigationsRouteWithChildren =
  AuthenticatedInvestigationsRoute._addFileChildren(
    AuthenticatedInvestigationsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInvestigationsRoute: typeof AuthenticatedInvestigationsRouteWithChildren
  AuthenticatedManualRoute: typeof AuthenticatedManualRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedAlertsHistoryRoute: typeof AuthenticatedAlertsHistoryRoute
  AuthenticatedAlertsNewRoute: typeof AuthenticatedAlertsNewRoute
  AuthenticatedEntitiesIdRoute: typeof AuthenticatedEntitiesIdRoute
  AuthenticatedGroupsIdRoute: typeof AuthenticatedGroupsIdRoute
  AuthenticatedMessagesIdRoute: typeof AuthenticatedMessagesIdRoute
  AuthenticatedProfilerIdRoute: typeof AuthenticatedProfilerIdRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedAlertsIndexRoute: typeof AuthenticatedAlertsIndexRoute
  AuthenticatedEntitiesIndexRoute: typeof AuthenticatedEntitiesIndexRoute
  AuthenticatedGroupsIndexRoute: typeof AuthenticatedGroupsIndexRoute
  AuthenticatedAlertsIdEditRoute: typeof AuthenticatedAlertsIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInvestigationsRoute:
    AuthenticatedInvestigationsRouteWithChildren,
  AuthenticatedManualRoute: AuthenticatedManualRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedAlertsHistoryRoute: AuthenticatedAlertsHistoryRoute,
  AuthenticatedAlertsNewRoute: AuthenticatedAlertsNewRoute,
  AuthenticatedEntitiesIdRoute: AuthenticatedEntitiesIdRoute,
  AuthenticatedGroupsIdRoute: AuthenticatedGroupsIdRoute,
  AuthenticatedMessagesIdRoute: AuthenticatedMessagesIdRoute,
  AuthenticatedProfilerIdRoute: AuthenticatedProfilerIdRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedAlertsIndexRoute: AuthenticatedAlertsIndexRoute,
  AuthenticatedEntitiesIndexRoute: AuthenticatedEntitiesIndexRoute,
  AuthenticatedGroupsIndexRoute: AuthenticatedGroupsIndexRoute,
  AuthenticatedAlertsIdEditRoute: AuthenticatedAlertsIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
